
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.266 36.668V12.4a.894.894 0 00-.278-.655.894.894 0 00-.656-.278H8.665a.894.894 0 00-.656.278.894.894 0 00-.277.655v24.268c0 .252.092.471.277.656a.897.897 0 00.656.277h46.667a.897.897 0 00.656-.277.898.898 0 00.278-.656zM59.998 12.4v31.734c0 1.284-.456 2.383-1.37 3.296-.914.914-2.013 1.371-3.296 1.371H39.465c0 .72.156 1.472.467 2.26.31.788.622 1.478.934 2.07.31.594.466 1.018.466 1.27 0 .505-.184.943-.554 1.312-.37.37-.808.555-1.313.555H24.532c-.505 0-.943-.185-1.312-.555a1.79 1.79 0 01-.554-1.312c0-.272.154-.7.466-1.284.311-.583.623-1.264.933-2.041.311-.778.467-1.537.467-2.275H8.665c-1.283 0-2.381-.457-3.295-1.37C4.455 46.516 4 45.417 4 44.133V12.4c0-1.282.455-2.38 1.37-3.296.914-.913 2.012-1.37 3.295-1.37h46.667c1.283 0 2.382.457 3.295 1.37.915.915 1.371 2.014 1.371 3.296z","fill-rule":"nonzero"}})])
          )
        }
      }
    